import {
  copyObj,
  getSafeUrl,
  useAppDispatch,
  useAppSelector,
  useGetInstByAccountQuery,
  useGetInstanceExtraInfoQuery,
  useGetVmStatusQuery,
  useLazyGetInstanceAccessUrlQuery,
  useSingleRegionLoginQuery
} from '@monorepo/shared';
import {
  findRedirectAccount,
  selectAccounts,
  selectRedirectAccount,
  updateCurrentAccount,
  updateIsRedirectChecked
} from '@monorepo/shared/store/accountSlice';
import { useEffect, useState } from 'react';
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext
} from 'react-router-dom';
import { Loader } from 'rsuite';
import {
  getAllOuNodes,
  selectOU,
  selectOUStatus,
  updateSelected
} from '@monorepo/shared/store/fcOuSlice';
import {
  selectDebugKey,
  selectPermission
} from '@monorepo/shared/store/authSlice';

const RedirectAccount = () => {
  const { redirect_obj } = useOutletContext<{
    redirect_obj: Record<string, any>;
  }>();
  const { state } = useLocation();
  const debugKey = useAppSelector(selectDebugKey);
  const debug_key = state?.debug_key;
  const requestAccount = useAppSelector(selectRedirectAccount);
  const [isRedirectValid, setIsRedirectValid] = useState<boolean>(false);
  const ouData = useAppSelector(selectOU);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const findRedirectNode = () => {
    let resObj = undefined;
    if (ouData) {
      const allOuNodes = getAllOuNodes(ouData) as Array<any>;
      const nodes = allOuNodes.filter((node: Record<string, any>) => {
        const data = node.data || {};
        if (data?.node_type === 'account') {
          const redirect_node_id = String(redirect_obj?.node_id || '');
          const redirect_access_user_id = String(
            redirect_obj?.access_from?.user_id || ''
          );
          const redirect_user_id = String(redirect_obj?.user_id || '');
          const redirect_account_id = String(redirect_obj?.account_id || '');
          const data_node_id = String(data?.account_node_id || '');
          const data_user_id = String(data?.user_id || '');
          const data_access_user_id = String(data?.access_from?.user_id || '');
          const data_account_id = String(data?.account_id || '');

          // org member account must has 'node_id', 'access_from.user_id'
          if (redirect_node_id) {
            return (
              redirect_node_id === data_node_id &&
              redirect_access_user_id === data_access_user_id
            );
            // sub accounts only match user_id
          } else if (redirect_user_id && Number(redirect_user_id) > 0) {
            return redirect_user_id === data_user_id;
            // master account match account_id
          } else {
            return redirect_account_id === data_account_id;
          }
        }
      });
      resObj = nodes?.[0];
      // console.info('account type: ', nodes, rAccount);
    }
    return resObj;
  };

  useEffect(() => {
    if (requestAccount?.account_id) {
      if (requestAccount?.account_id > 0) {
        // setIsRedirectValid(true);
        const redirectNode = findRedirectNode();
        redirectNode && dispatch(updateSelected(copyObj(redirectNode)));
        dispatch(updateCurrentAccount(requestAccount));
      } else {
        setIsRedirectValid(false);
        console.info(
          '================= Cannot find redirect account, need reselect account from cred/ou'
        );
        navigate(`/cred/ou`, {
          state: {
            debug_key: debug_key || debugKey
          }
        });
        dispatch(updateIsRedirectChecked(true));
      }
    } else {
      setIsRedirectValid(false);
      dispatch(updateIsRedirectChecked(true));
    }
  }, [requestAccount]);
  return isRedirectValid ? (
    <Loader center content="Please wait while redirecting..." />
  ) : (
    <Outlet context={useOutletContext} />
  );
};

export default RedirectAccount;
